import React, { useEffect, useState } from "react";
import Header from "../../components/header/Header";
import PageHeading from "../../components/pageHeading/PageHeading";
import Footer from "../../components/footer/Footer";
import "./booking.scss";

import { LocationIcon } from "../../components/Icons";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setLoader } from "../../slice/commonSlice";
import { fetchProviderDetails } from "../../services/hireProvider.service";
import { twoDecimalPlaces } from "../../utils/common";
const BookingInfo = () => {
  const location = useLocation();
  const id = location.state?.providerId;
  const dispatch = useDispatch();
  const [profile, setProfile] = useState();

  useEffect(() => {
    if (id) {
      getProfile();
    }
  }, [id]);

  const getProfile = async () => {
    let payload = {
      _id: id,
    };
    await dispatch(setLoader(true));
    try {
      const response = await fetchProviderDetails(payload);
      await dispatch(setLoader(false));
      if (response.status) {
        setProfile(response.data);
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };
  return (
    <>
      <Header />
      <PageHeading title="Booking" />
      <div className="main-container">
        <div className="booking-wrapper-main">
          <div className="booking-wrapper">
            <div className="booking-title">Service Details</div>
            <div className="booking-content-wrap">
              <div className="booking-left">{location.state?.serviceName}</div>
              <div className="booking-right">
                <div className="icon-wrap">
                  <LocationIcon />
                </div>
                <div className="booking-location-text">
                  {profile?.personData?.location}
                </div>
              </div>
            </div>
          </div>

          <div className="booking-wrapper">
            <div className="booking-title">Payment Details</div>
            <div className="payment-detail-wrap">
              <table className="table">
                <tr>
                  <td>Charge</td>
                  <td>
                    {location.state?.payload?.charge
                      ? `$${twoDecimalPlaces(location.state?.payload?.charge)}`
                      : `$${location.state?.rate}/hr`}
                  </td>
                </tr>
                <tr>
                  <td>Helpr app fee & Transaction fee</td>
                  <td>
                    {location.state?.payload?.taxAmount
                      ? `$${twoDecimalPlaces(
                          location.state?.payload?.taxAmount
                        )}`
                      : "-"}
                  </td>
                </tr>
                <tr>
                  <td className="total">Total</td>
                  <td>
                    {location.state?.payload?.total
                      ? `$${twoDecimalPlaces(location.state?.payload?.total)}`
                      : "-"}
                  </td>
                </tr>
                <tr>
                  <td>Payment Mode</td>
                  <td>Credit Card</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BookingInfo;
